<script lang="ts">
  import DOMPurify from 'dompurify'
  import Typeahead from 'svelte-typeahead'
  import prompts from '../awesome-chatgpt-prompts/prompts.csv'

  import type { Message } from './Types.svelte'
  import { editMessage, } from './Storage.svelte'


  const inputPrompt = (prompt: string) => {
    msg.content = prompt
    editMessage(chatId, msg)
  }

  const extract = (prompt: typeof prompts[0]) => prompt.act

  export let chatId : int
  export let msg : Message
</script>

<div class="columns is-centered">
  <div class="column is-half">
    <Typeahead
      data={prompts}
      {extract}
      label="选择预置的提示词"
      hideLabel
      showDropdownOnFocus
      showAllResultsOnFocus
      inputAfterSelect="clear"
      on:select={({ detail }) => inputPrompt(detail.original.prompt)}
      placeholder="选择预置的提示词 👇"
      let:result
    >
      <a class="dropdown-item" href="#top" on:click|preventDefault title="{result.original.prompt}">
        <!--
          Sanitize result.string because Typeahead introduces HTML tags and prompt
          strings are untrusted.
        -->
        {@html DOMPurify.sanitize(result.string, { ALLOWED_TAGS: ['mark'] })}
      </a>
    </Typeahead>
  </div>
</div>

<!--div class="columns is-centered">
  <div class="column is-half has-text-centered">or type below:</div>
</div-->
